import { ConfirmCancelChangesDialogComponent } from "./../dialog/confirm-cancel-changes-dialog/confirm-cancel-changes-dialog.component";
import { Helper } from "./../common/helper";
import { AuthService } from "./../services/auth.service";
import { Enums } from "./../common/enums";
import { MessageService } from "../services/message.service";
import { Message } from "../common/message";
import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import _ from "lodash";

import {
  MatDialog,
  NativeDateAdapter,
  DateAdapter,
  MAT_DATE_FORMATS,
} from "@angular/material";
import { AppDateAdapter, APP_DATE_FORMATS } from "./date.adapter";

import { PowertrainService } from "../services/powertrain.service";
import { forkJoin } from "rxjs";
import { QaVisit } from "../models/qavisit";
import { QavisitService } from "../services/qavisit.service";
import { TroubleshootingqaService } from "../services/troubleshootingqa.service";
import { TroubleshootingqaboxService } from "../services/troubleshootingqabox.service";
import { QavisitnotacceptedpointsService } from "../services/qavisitnotacceptedpoints.service";

let ELEMENT_DATA = [];

@Component({
  selector: "app-qavisit",
  templateUrl: "./qavisit.component.html",
  styleUrls: ["./qavisit.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    },
  ],
})
export class QavisitComponent implements OnInit {
  @Input() title: string = "";
  @Input() isReviewed: boolean = false;
  @Input() status: number = null;
  @Input() hideActionsColumn: boolean = false;

  noMoreData: boolean = false;
  isDataLoaded: boolean = false;
  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[] = [];
  visitColumns: string[] = [
    "SN",
    "date",
    "timein",
    "timeout",
    "trainno",
    "powertrain",
    "engine1",
    "engine2",
    "reviewed",
    "updatedBy",
    "created",
  ];

  displayedColumns: string[];
  dataSource = new MatTableDataSource();
  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  powerTrains: any;
  engines: any;
  troubleshooting: any;
  troubleshootingbox: any;
  troubleShootingType = Enums.troubhleShootingType;
  resource: QaVisit = new QaVisit();
  searchObject: any = {
    powerCoach: null,
    dateFrom: null,
    dateTo: null,
  };
  searchedEngines: any;
  searchedList: any;
  pageIndex: number = 0;
  pageSize: number = 25;
  totalCount: number = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private ptService: PowertrainService,
    private qavisitnotacceptedpointsService: QavisitnotacceptedpointsService,
    private service: QavisitService,
    private formBuilder: FormBuilder,
    private msg: MessageService,
    private authService: AuthService,
    private tsService: TroubleshootingqaService,
    private tsboxService: TroubleshootingqaboxService
  ) {}

  ngOnInit() {
    this.setMessageForm();
    this.initData();
    this.getTableColumns();
  }

  clearDates() {
    this.searchObject.dateFrom = null;
    this.searchObject.dateTo = null;
  }

  getMoreData() {
    this.service
      .getAllResources(
        this.searchObject.powerCoach,
        this.isReviewed,
        ELEMENT_DATA.length,
        25,
        this.searchObject.dateFrom,
        this.searchObject.dateTo
      )
      .subscribe((result: any) => {
        //fetch visits
        if (result && result.length) {
          if (result.length < 25) this.noMoreData = true;
          ELEMENT_DATA = ELEMENT_DATA.concat(result);
          this.ELEMENT_DATA = ELEMENT_DATA;
          this.updateDataSource();
        } else {
          this.noMoreData = true;
          this.updateDataSource();
        }
      });
  }

  showOpenVisitButton(element: any): boolean {
    return this.isVisit();
  }

  //serach
  searchByPowerCoach(powerCoach) {
    //this.searchedList = [];
    if (powerCoach && powerCoach != "null") {
      for (let obj of this.powerTrains) {
        if (obj.id == powerCoach) {
          if (obj && obj.motors && obj.motors.length) {
            this.searchedEngines = obj.motors;
            return;
          } else {
            this.searchedEngines = [];
            return;
          }
        }
      }
    } else {
      this.searchedEngines = [];
    }
  }

  ///////////////////////////init data
  getTableColumns() {
    this.displayedColumns = this.visitColumns;
    if (!this.hideActionsColumn) {
      this.displayedColumns.push("actions");
    }
  }

  initData() {
    forkJoin([
      this.getPowertrains(),
      this.getTroubleShooting(),
      this.getTroubleShootingbox(),
    ]).subscribe(
      (results: any) => {
        this.isDataLoaded = true;

        if (!results) return;

        if (results[0] && results[0].length) {
          this.powerTrains = this.powerTrains.concat(results[0]);
        }

        if (results[1] && results[1].length) {
          this.troubleshooting = this.troubleshooting.concat(results[1]);
          this.setActionStatus(this.troubleshooting, 1);
        }
        if (results[2] && results[2].length) {
          this.troubleshootingbox = this.troubleshootingbox.concat(results[2]);
          this.setActionBoxStatus(this.troubleshootingbox, 1);
        }
      },
      (err: any) => {
        this.msg.alert(Message.ERROR_LOAD_INIT_DATA);
      }
    );
  }

  searchVisits() {
    this.noMoreData = false;
    forkJoin([this.getResources(), this.getVisitCount()]).subscribe(
      (results: any) => {
        //fetch visits
        if (results[0] && results[0].length) {
          if (results[0].length < 25) this.noMoreData = true;
          ELEMENT_DATA = [];
          ELEMENT_DATA = ELEMENT_DATA.concat(results[0]);
          this.ELEMENT_DATA = ELEMENT_DATA;
          this.updateDataSource();
        } else {
          this.noMoreData = true;
          ELEMENT_DATA = [];
          this.ELEMENT_DATA = ELEMENT_DATA;
          this.updateDataSource();
        }
        this.totalCount = results[1].count;
      },
      (err: any) => {
        this.msg.alert(Message.ERROR_LOAD_INIT_DATA);
      }
    );
  }

  getVisitCount() {
    return this.service.getAllResourcesCount(
      this.searchObject.powerCoach,
      this.isReviewed,
      this.searchObject.dateFrom,
      this.searchObject.dateTo,
      this.status
    );
  }

  setActionStatus(actions: any, status: any) {
    for (let action of actions) {
      action.engine1status = status;
      action.engine2status = status;
    }
  }

  setActionBoxStatus(actions: any, status: any) {
    for (let action of actions) {
      action.status = status;
    }
  }

  getTroubleShooting() {
    this.troubleshooting = [];
    return this.tsService.getAll();
  }

  getTroubleShootingbox() {
    this.troubleshootingbox = [];
    return this.tsboxService.getAll();
  }

  getResources() {
    ELEMENT_DATA = [];
    this.ELEMENT_DATA = ELEMENT_DATA;
    return this.service.getAllResources(
      this.searchObject.powerCoach,
      this.isReviewed,
      ELEMENT_DATA.length,
      25,
      this.searchObject.dateFrom,
      this.searchObject.dateTo,
      this.status
    );
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      powertrainId: ["", Validators.required],
      date: ["", Validators.required],
      timein: ["", Validators.required],
      timeout: ["", Validators.required],
      trainno: ["", Validators.required],
      engine1: ["", Validators.required],
      engine2: ["", Validators.required],
      generator1: ["", Validators.required],
      generator2: ["", Validators.required],

      engine1speed: ["", Validators.required],
      engine1volt: ["", Validators.required],
      engine1temp: ["", Validators.required],
      engine1amp: ["", Validators.required],
      engine1oilpressure: ["", Validators.required],
      engine1hoursread: ["", Validators.required],

      engine2speed: ["", Validators.required],
      engine2volt: ["", Validators.required],
      engine2temp: ["", Validators.required],
      engine2amp: ["", Validators.required],
      engine2oilpressure: ["", Validators.required],
      engine2hoursread: ["", Validators.required],

      troubleshooting: ["", Validators.required],
      troubleshootingbox: ["", Validators.required],

      notes1: ["", Validators.required],
      notes2: ["", Validators.required],

      supervisor: ["", Validators.required],
      engineer: ["", Validators.required],
    });
  }

  ///////////////////////////////////

  updateDataSource(list?: any) {
    if (list) {
      this.dataSource = new MatTableDataSource<any>(list);
      this.dataSource.paginator = this.paginator;
      return;
    }

    if (ELEMENT_DATA && ELEMENT_DATA.length) {
      this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    } else {
      this.dataSource = new MatTableDataSource<any>([]);
    }
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.resetForm();
    this.isFormDisplay = true;
    this.resource.troubleshooting = this.troubleshooting;
    this.resource.troubleshootingbox = this.troubleshootingbox;
  }

  displayTable() {
    this.isFormDisplay = false;
    this.resetForm();
  }

  goBack() {
    this.isFormDisplay = false;
  }

  selectAll(arr: any) {
    for (let obj of arr) {
      obj.status = true;
    }
  }

  isFormDisabled(): boolean {
    let isVisitUsedByDataEntry =
      this.resource.id && this.authService.isQaDataEntry();

    let isReviewed = this.resource.reviewed;

    if (isVisitUsedByDataEntry || isReviewed) return true;
    else return false;
  }

  onSave() {
    this.submitted = true;
    const list = [
      "id",
      "notes1",
      "notes2",
      "created",
      "updated",
      "reviewed",
      "reviewerId",
      "accountId",
      "reset",
      "status",
    ];

    for (let key in this.resource) {
      if (!this.resource[key] && list.indexOf(key) === -1) return;
    }

    if (this.resource.id) {
      this.resource.reviewed = true;
      this.resource.reviewerId = this.authService.getUserData().id;
      this.resource.status = this.checkQaVisitStatus(this.resource);
      this.updateElement();
    } else {
      this.resource.status = 0;
      this.resource.accountId = this.authService.getUserData().id;
      this.addElement();
    }
  }

  saveQAVisitNotAcceptedPoints(resource: any, result: any) {
    if (!resource.troubleshooting || !resource.troubleshootingbox) return;

    const notAcceptedPoints = [];

    for (let item of resource.troubleshooting) {
      if (item.engine1status == 0) {
        notAcceptedPoints.push({
          trainno: resource.trainno,
          point: item.name,
          pointId: item.id,
          pointType: item.cat,
          powercoach: this.resource.powertrain.code,
          powercoachId: this.resource.powertrainId,
          engineId: this.resource.engine1,
          engineType: "1",
          date: this.resource.date,
          qavisitId: this.resource.id,
        });
      }
      if (item.engine2status == 0) {
        notAcceptedPoints.push({
          trainno: resource.trainno,
          point: item.name,
          pointId: item.id,
          pointType: item.cat,
          powercoach: this.resource.powertrain.code,
          powercoachId: this.resource.powertrainId,
          engineId: this.resource.engine2,
          engineType: "2",
          date: this.resource.date,
          qavisitId: this.resource.id,
        });
      }
    }
    for (let item of resource.troubleshootingbox) {
      if (item.status == 0) {
        notAcceptedPoints.push({
          trainno: resource.trainno,
          point: `${item.name} | ${item.desc}`,
          pointId: item.id,
          pointType: "BOX",
          powercoach: this.resource.powertrain.code,
          powercoachId: this.resource.powertrainId,
          engineId: "",
          engineType: "",
          date: this.resource.date,
          qavisitId: this.resource.id,
        });
      }
    }

    this.qavisitnotacceptedpointsService
      .create(notAcceptedPoints)
      .subscribe(() => {
        result.powertrain = Helper.getObjectFromAnArrayByObjectId(
          this.powerTrains,
          result.powertrainId
        );

        result.addedBy = this.authService.getUserData();
        ELEMENT_DATA.forEach((elem, index) => {
          if (elem.id === this.resource.id) {
            ELEMENT_DATA.splice(index, 1, result);
            return;
          }
        });
        this.updateDataSource();
        this.resetForm(true);
        this.msg.alert(Message.UPDATE);
      });
  }

  checkQaVisitStatus(data: QaVisit) {
    let status: number = 1;
    for (let x of data.troubleshooting) {
      if (x.engine1status == 0) {
        status = 2;
        break;
      }
      if (x.engine2status == 0) {
        status = 2;
        break;
      }
    }
    for (let x of data.troubleshootingbox) {
      if (x.status == 0) {
        status = 2;
        break;
      }
    }
    return status;
  }

  getPowertrains() {
    this.powerTrains = [];
    this.engines = [];
    return this.ptService.getAll();
  }

  onPowerTrainChange(pt) {
    for (var obj of this.powerTrains) {
      if (obj.id == pt) {
        if (obj && obj.motors && obj.motors.length) {
          this.resource.powertrain = obj;
          this.resource.powertrainId = pt;
          this.resource.engine1 = obj.motors[1].name || "";
          this.resource.generator1 = obj.motors[1].code || "";
          this.resource.engine2 = obj.motors[0].name || "";
          this.resource.generator2 = obj.motors[0].code || "";
          return;
        } else {
          this.resource.powertrainId = null;
          this.resource.engine1 = "";
          this.resource.generator1 = "";
          this.resource.engine2 = "";
          this.resource.generator2 = "";
          return;
        }
      }
    }
    this.resource.engine1 = "";
    this.resource.generator1 = "";
    this.resource.engine2 = "";
    this.resource.generator2 = "";
  }

  resetForm(ret?: boolean) {
    this.setActionStatus(this.troubleshooting, 1);
    this.setActionBoxStatus(this.troubleshootingbox, 1);
    this.resource.reset();
    this.form.reset();
    this.submitted = false;
    if (ret) this.isFormDisplay = false;
  }

  isVisit() {
    return true;
  }

  addElement() {
    /**
     * check for last visit update from audit
     */

    this.resource.accountId = this.authService.getUserData().id;

    this.service.create(this.resource).subscribe((result: any) => {
      this.msg.alert(Message.SAVE);
      result.powertrain = Helper.getObjectFromAnArrayByObjectId(
        this.powerTrains,
        result.powertrainId
      );
      result.addedBy = this.authService.getUserData();
      ELEMENT_DATA.unshift(result);
      this.updateDataSource();
      this.resetForm(true);
    });
  }

  updateElement() {
    this.service.update(this.resource).subscribe((result: any) => {
      this.saveQAVisitNotAcceptedPoints(
        JSON.parse(JSON.stringify(this.resource)),
        result
      );
    });
  }

  editElement(ele: QaVisit) {
    this.resource = new QaVisit();
    this.isFormDisplay = true;
    this.isAddNew = false;
    for (let key in ele) {
      if (key != "reset") this.resource[key] = ele[key];
    }
    this.onPowerTrainChange(this.resource.powertrainId);
  }

  changeActionStatus(action: any, index: number, value: number) {
    if (index === 1) {
      action.engine1status = value;
    } else {
      action.engine2status = value;
    }
  }

  onTroubleshootingBoxChange(action: any, value) {
    // action.status = !action.status;
    action.status = value;
  }

  rollbackElement(ele: any) {
    this.dialog
      .open(ConfirmCancelChangesDialogComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result === "true") {
          this.service.cancelChanges(ele).subscribe((result) => {
            this.service
              .deleteQAVisisNotAcceptedPoints(ele.id)
              .subscribe(() => {
                this.msg.alert(Message.CANCEL_CHANGES);
                let index = ELEMENT_DATA.indexOf(ele);
                ELEMENT_DATA.splice(index, 1);
                this.updateDataSource();
              });
          });
        } else {
          return;
        }
      });
  }

  getIndex(element: QaVisit) {
    const i = _.findIndex(ELEMENT_DATA, element);
    return i + 1;
  }
}
